import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Layout } from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import ContractEditor from "@/pages/ContractEditor";
import SignInPerson from "@/pages/SignInPerson";
import RemoteSign from "@/pages/RemoteSign";
import Users from "@/pages/Users";
import AllergySheet from "@/pages/AllergySheet";
import MenuArt from "@/pages/MenuArt";
import Quotes from "@/pages/Quotes";
import QuoteEditor from "@/pages/QuoteEditor";
import Today from "@/pages/Today";
import CalendarPage from "@/pages/CalendarPage";
import Leads from "@/pages/Leads";
import Clients from "@/pages/Clients";
import Catalog from "@/pages/Catalog";
import ClientArea from "@/pages/ClientArea";
import PublicQuote from "@/pages/PublicQuote";
import ClientProfile from "@/pages/ClientProfile";
import BrochureView from "@/pages/BrochureView";
import Team from "@/pages/Team";
import Report from "@/pages/Report";
import PublicLeadForm from "@/pages/PublicLeadForm";
import Rsvp from "@/pages/Rsvp";
import Survey from "@/pages/Survey";
import Tasting from "@/pages/Tasting";
import FloorPlans from "@/pages/FloorPlans";
import Fornitori from "@/pages/Fornitori";
import Foto from "@/pages/Foto";
import PlanPrint from "@/pages/PlanPrint";
import Hostess from "@/pages/Hostess";
import Privacy from "@/pages/Privacy";
import LiveService from "@/pages/LiveService";

function Protected({ children, admin }) {
  const { user } = useAuth();
  if (user === null) return <div className="p-10 text-sm text-muted-foreground" data-testid="auth-loading">Caricamento…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (admin && user.role !== "admin") return <Navigate to="/" replace />;
  return <Layout>{children}</Layout>;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/firma/:token" element={<RemoteSign />} />
          <Route path="/brochure/:token" element={<BrochureView />} />
          <Route path="/area/:token" element={<ClientArea />} />
          <Route path="/preventivo/:token" element={<PublicQuote />} />
          <Route path="/richiesta" element={<PublicLeadForm />} />
          <Route path="/conferma/:token" element={<Rsvp />} />
          <Route path="/questionario/:token" element={<Survey />} />
          <Route path="/squadra" element={<Protected><Team /></Protected>} />
          <Route path="/report" element={<Protected><Report /></Protected>} />
          <Route path="/contratti/:id/degustazione" element={<Protected><Tasting /></Protected>} />
          <Route path="/menu-artistico/:src/:id" element={<Protected><MenuArt /></Protected>} />
          <Route path="/contratti/:id/allergie" element={<Protected><AllergySheet /></Protected>} />
          <Route path="/sale" element={<Protected><FloorPlans /></Protected>} />
          <Route path="/sale/:id/stampa" element={<Protected><PlanPrint /></Protected>} />
          <Route path="/sala/:id" element={<Protected><Hostess /></Protected>} />
          <Route path="/hostess/:token" element={<Hostess />} />
          <Route path="/fornitori/:token" element={<Fornitori />} />
          <Route path="/foto/:token" element={<Foto />} />
          <Route path="/privacy" element={<Protected><Privacy /></Protected>} />
          <Route path="/servizio/:id" element={<Protected><LiveService /></Protected>} />
          <Route path="/" element={<Protected><Today /></Protected>} />
          <Route path="/contratti" element={<Protected><Dashboard /></Protected>} />
          <Route path="/calendario" element={<Protected><CalendarPage /></Protected>} />
          <Route path="/richieste" element={<Protected><Leads /></Protected>} />
          <Route path="/clienti/scheda" element={<Protected><ClientProfile /></Protected>} />
          <Route path="/clienti" element={<Protected><Clients /></Protected>} />
          <Route path="/listino" element={<Protected><Catalog /></Protected>} />
          <Route path="/contratti/:id" element={<Protected><ContractEditor /></Protected>} />
          <Route path="/contratti/:id/firma" element={<Protected><SignInPerson /></Protected>} />
          <Route path="/preventivi" element={<Protected><Quotes /></Protected>} />
          <Route path="/preventivi/:id" element={<Protected><QuoteEditor /></Protected>} />
          <Route path="/utenti" element={<Protected admin><Users /></Protected>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </AuthProvider>
  );
}

export default App;
